import {
	CREATE_NOTIFICATION_REQUEST,
	CREATE_NOTIFICATION_SUCCESS,
	CREATE_NOTIFICATION_FAIL,
	FETCH_NOTIFICATIONS_REQUEST,
	FETCH_NOTIFICATIONS_SUCCESS,
	FETCH_NOTIFICATIONS_FAIL,
	UPDATE_NOTIFICATION_REQUEST,
	UPDATE_NOTIFICATION_SUCCESS,
	UPDATE_NOTIFICATION_FAIL,
	DELETE_NOTIFICATION_REQUEST,
	DELETE_NOTIFICATION_SUCCESS,
	DELETE_NOTIFICATION_FAIL,
	FETCH_NOTIFICATION_REQUEST,
	FETCH_NOTIFICATION_SUCCESS,
	FETCH_NOTIFICATION_FAIL,
	FETCH_STORES_REQUEST,
	FETCH_STORES_SUCCESS,
	FETCH_STORES_FAIL,
} from "../constants/notification";

function createNotificationReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}

	switch (action.type) {
		case CREATE_NOTIFICATION_REQUEST:
			return { loading: true };
		case CREATE_NOTIFICATION_SUCCESS:
			return {
				loading: false,
				success: true,
				notification: action.payload.data,
			};
		case CREATE_NOTIFICATION_FAIL:
			return { loading: false, success: false, error: action.payload };
		default:
			return state;
	}
}

function fetchNotificationsReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			notificationUpdated: false,
			error: null,
			notificationDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_NOTIFICATIONS_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_NOTIFICATIONS_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				notifications: action.payload,
			};
		case FETCH_NOTIFICATIONS_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateNotificationReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", error: null, notificationUpdated: false };
	}
	switch (action.type) {
		case UPDATE_NOTIFICATION_REQUEST:
			return { loading: true };
		case UPDATE_NOTIFICATION_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				notificationUpdated: true,
			};
		case UPDATE_NOTIFICATION_FAIL:
			return {
				loading: false,
				notificationUpdated: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

function deleteNotificationReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case DELETE_NOTIFICATION_REQUEST:
			return { loading: true };
		case DELETE_NOTIFICATION_SUCCESS:
			return {
				loading: false,
				notificationDeleted: true,
			};
		case DELETE_NOTIFICATION_FAIL:
			return {
				loading: false,
				notificationDeleted: false,
				error: action.payload,
			};
		default:
			return state;
	}
}

function fetchNotificationReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			error: null,
			notificationUpdated: false,
			notificationDeleted: false,
		};
	}

	switch (action.type) {
		case FETCH_NOTIFICATION_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_NOTIFICATION_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				notification: action.payload,
			};
		case FETCH_NOTIFICATION_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function fetchStoresReducer(state, action) {
	if (typeof state === "undefined") {
		state = {
			status: "IDLE",
			storeUpdated: false,
			error: null,
			storeDeleted: false,
		};
	}
	switch (action.type) {
		case FETCH_STORES_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_STORES_SUCCESS:
			return {
				...state,
				loading: false,
				status: "SUCCEEDED",
				stores: action.payload.data,
			};
		case FETCH_STORES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

export {
	createNotificationReducer,
	fetchNotificationsReducer,
	updateNotificationReducer,
	deleteNotificationReducer,
	fetchNotificationReducer,
	fetchStoresReducer,
};
